/**
 * street.ts
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 단지 탭에서 사용하는 데이터의 모음입니다.
 * 일부 데이터는 직접 단지 페이지 컴포넌트에 넣는 경우도 존재합니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

import system_01_01 from 'assets/common/systems/system_01_01.jpg';
import system_01_02 from 'assets/common/systems/system_01_02.jpg';
import system_01_03 from 'assets/common/systems/system_01_03.jpg';
import system_01_04 from 'assets/common/systems/system_01_04.jpg';
import system_01_05 from 'assets/common/systems/system_01_05.jpg';
import system_01_06 from 'assets/common/systems/system_01_06.jpg';
import system_01_07 from 'assets/common/systems/system_01_07.jpg';
import system_01_08 from 'assets/common/systems/system_01_08.jpg';

import system_02_01 from 'assets/common/systems/system_02_01.jpg';
import system_02_02 from 'assets/common/systems/system_02_02.jpg';
import system_02_03 from 'assets/common/systems/system_02_03.jpg';
import system_02_04 from 'assets/common/systems/system_02_04.jpg';
import system_02_05 from 'assets/common/systems/system_02_05.jpg';
import system_02_06 from 'assets/common/systems/system_02_06.jpg';
import system_02_07 from 'assets/common/systems/system_02_07.jpg';
import system_02_08 from 'assets/common/systems/system_02_08.jpg';
import system_02_09 from 'assets/common/systems/system_02_09.jpg';
import system_02_10 from 'assets/common/systems/system_02_10.jpg';

import system_03_01 from 'assets/common/systems/system_03_01.jpg';
import system_03_02 from 'assets/common/systems/system_03_02.jpg';
import system_03_03 from 'assets/common/systems/system_03_03.jpg';
import system_03_04 from 'assets/common/systems/system_03_04.jpg';
import system_03_05 from 'assets/common/systems/system_03_05.jpg';
import system_03_06 from 'assets/common/systems/system_03_06.jpg';
import system_03_07 from 'assets/common/systems/system_03_07.jpg';
import system_03_08 from 'assets/common/systems/system_03_08.jpg';
import system_03_09 from 'assets/common/systems/system_03_09.jpg';
import system_03_10 from 'assets/common/systems/system_03_10.jpg';

import system_04_01 from 'assets/common/systems/system_04_01.jpg';
import system_04_02 from 'assets/common/systems/system_04_02.jpg';
import system_04_03 from 'assets/common/systems/system_04_03.jpg';
import system_04_04 from 'assets/common/systems/system_04_04.jpg';
import system_04_05 from 'assets/common/systems/system_04_05.jpg';
import system_04_06 from 'assets/common/systems/system_04_06.jpg';
import system_04_07 from 'assets/common/systems/system_04_07.jpg';
import system_04_08 from 'assets/common/systems/system_04_08.jpg';

import system_05_01 from 'assets/common/systems/system_05_01.jpg';
import system_05_02 from 'assets/common/systems/system_05_02.jpg';
import system_05_03 from 'assets/common/systems/system_05_03.jpg';
import system_05_04 from 'assets/common/systems/system_05_04.jpg';


/**
 * 탭 메뉴 > 단지에서 특징에 사용 하는 데이터 (Desktop, Mobile)
 */
export const listPromition = [
  {
    title: "힐링 가득한 금오산을 품은 그리너리 라이프",
    desc: "금오산을 품은 청정한 입지에서 자연을 가까이서 마주하는 쾌적한 일상을 경험할 수 있습니다."
  },
  {
    title: "생활에 건강한 활력을 더하는 커뮤니티 시설",
    desc: "작은 도서관, 입주민회의실, 다함께 돌봄센터, 실내 골프연습장, 피트니스 센터, 개인오피스 등 입주민들을 위한 다채로운 편의시설이 준비되어 있습니다."
  },
  {
    title: "구미시 최초 입체적 주거플랫폼 'C2하우스'",
    desc: "구미시 최초로 고객들의 라이프스타일 니즈를 반영하는 입체적 주거 플랫폼인 'C2하우스’가 도입되어 입주민의 만족도를 높여줍니다."
  },
  {
    title: "미세먼지 걱정 없는 스마트 클린 케어 솔루션",
    desc: "스마트 공기제어 시스템과 미세먼지 저감 식재 등으로 늘 쾌적한 주거 환경을 유지할 수 있습니다."
  }
]

/**
 * 탭 메뉴 > 단지의 동호 배치에서 사용 하는 데이터 (Desktop, Mobile)
 */
export const listContent = [
  {
    id: 1,
    tit: '84㎡A',
    subtit: '16', 
    subtit02: '123', 
    total: '153', 
    color: 'bg-01' // color css
  },
  {
    id: 2,
    tit: '84㎡B',
    subtit: '259', 
    subtit02: '22', 
    total: '9', 
    color: 'bg-02' // color css
  },
  {
    id: 3,
    tit: '84㎡C',
    subtit: '48', 
    subtit02: '8', 
    total: '9', 
    color: 'bg-03' // color css
  },
  {
    id: 4,
    tit: '108㎡',
    subtit: '159', 
    subtit02: '8', 
    total: '9', 
    color: 'bg-04' // color css
  },
  {
    id: 5,
    tit: '116㎡',
    subtit: '138', 
    subtit02: '8', 
    total: '9', 
    color: 'bg-05' // color css
  },
];


/**
 * 시스템 (Expert Solution, 구) 인포그래픽 시스템) 표출 내용
 * 이 리스트는 어드민 페이지의 브랜드 > Expert Solution의 모든 리스트 중에서
 * 표출시키고자 하는 콘텐츠만 표출할 수 있게 합니다.
 * 
 * 표출하고자 하는 타이틀의 값을 여기에 넣어주세요. 
 * 이 배열에 있는 값만이 Expert Solution 리스트에 표출됩니다.
 * 
 * ※ 아래 배열 순서로 표출되게 적용되게 하였습니다.
 */
export const expertSolutionList = [

  // 안전 시스템 (type = 1)
  {
    title: "범죄 안심 시스템",
    description: "최첨단 보안시설을 통하여 개인의 사생활을 철저히 보호하여 안전한 단지를 만듭니다. 위급한 재난상황에 대처 할 수 있는 다양한 안전시설로 위험을 최소화합니다.",
    img: system_01_01,
    type: 1,
  },
  {
    title: "블랙박스 도어폰",
    description: "부재중 방문자를 스마트폰으로 확인할 수 있으며, 현관문 앞에 수상한 사람이 포착되면 자동으로 녹화하여 범죄를 예방할 수 있습니다.",
    img: system_01_02,
    type: 1,
  },
  {
    title: "차량번호인식 주차관제 시스템 (+입차 알림/월패드)+방문차량 예약 시스템",
    description: "차량번호 인식시스템으로 아파트에 출입하는 차량을 효율적으로 통제할 수 있습니다. 불필요한 외부차량의 출입을 통제하여 사전에 보안을 강화하고, 가족, 지인 초청 시 방문차량을 사전 등록하면 번거로운 통화없이 쉽게 주차장으로 진입이 가능하여 편리합니다.",
    img: system_01_03,
    type: 1,
  },
  {
    title: "저층부 및 최상층 방범 감지기",
    description: "동체 감지기를 설치해 외부인의 침입을 사전에 차단하므로 저층/최상층 세대도 안심할 수 있습니다.",
    img: system_01_04,
    type: 1,
  },
  {
    title: "고해상도 CCTV",
    description: "녹화 시스템을 갖춘 고화질 CCTV를 단지 내 설치해 실시간 감시 및 녹화를 통해 입주민의 안전을 지켜줍니다.",
    img: system_01_05,
    type: 1,
  },
  {
    title: "입출차 관리 시스템",
    description: "차량번호 인식시스템을 설치하여 아파트에 출입하는 차량을 효율적으로 통제합니다. 방문차량의 출차 여부, 평균 주차대수 등 확인이 가능한 시스템으로 단지 내 보안 향상 뿐만 아니라 효율적인 주차장 운용이 가능합니다.",
    img: system_01_06,
    type: 1,
  },
  {
    title: "비상벨",
    description: "지하주차장에 비상 콜버튼을 설치하여 위급상황 발생시 신속하게 대처합니다.",
    img: system_01_07,
    type: 1,
  },
  {
    title: "가스/전기 자동 차단기",
    description: "화재가 감지되면 자동으로 전기와 가스를 차단하는 시스템으로 화재가 커지는 것을 사전 예방합니다.",
    img: system_01_08,
    type: 1,
  },

  // 절약 시스템 (type = 2)
  {
    title: "끊김없는 단열",
    description: "끊어지지 않는 단열설계로 더욱 따뜻한 집을 만들어 줍니다. 모서리부분까지 끊김없는 단열라인과 디테일한 열교설계가 적용 되어 결로 발생을 획기적으로 차단합니다. (세대간벽 제외)",
    img: system_02_01,
    type: 2,
  },
  {
    title: "일괄소등 스위치 \n(+세대 내 엘리베이터 호출)",
    description: "세대 내부 전등(센서등 제외)과 가스를 일괄 차단해 주는 스위치가 현관옆에 설치되어 외출 시 발생할 수 있는 에너지 낭비를 예방하고 세대 내 엘리베이터 호출로 생활이 더욱 편리해 집니다.",
    img: system_02_02,
    type: 2,
  },
  {
    title: "세대&외부 100% LED 전등",
    description: "일반 등기구보다 수명이 더 길고 밝은 LED 등기구를 세대와 단지 전체에 설치하여 에너지 비용을 절감합니다.",
    img: system_02_03,
    type: 2,
  },
  {
    title: "대기전력 차단 시스템",
    description: "미사용시에도 전력소모가 되는 대기전력을 차단 할 수 있는 콘센트를 설치하여 에너지를 절약합니다. (거실 / 침실 / 주방 적용) 외부에서도 스마트폰으로 on/off가 가능합니다.",
    img: system_02_04,
    type: 2,
  },
  {
    title: "에너지 사용량 모니터링 / 에너지 매니지먼트 시스템 (EMS)",
    description: "월패드와 스마트폰을 통해 에너지 사용현황을 바로 확인할 수 있고, 에너지 절약 프로그램을 통해 에너지를 똑똑하게 절약하는 생활습관을 만들어 줍니다. ",
    img: system_02_05,
    type: 2,
  },
  {
    title: "실별 온도조절 시스템",
    description: "가족 구성원이 실별로 희망온도를 유지할 수 있는 실별 온도조절 기능으로 구성원 각자에게 쾌적함을 제공하고, 사용하지 않는 방의 에너지는 차단해 난방, 가스비의 소비를 줄여줍니다",
    img: system_02_06,
    type: 2,
  },
  {
    title: "터치식 주방 수전",
    description: "설거지를 하다가 손등으로 가볍게 터치만 해도 물이 멈춰 물 낭비를 막아줍니다.",
    img: system_02_07,
    type: 2,
  },
  {
    title: "고효율 콘덴싱 보일러",
    description: "일반 보일러 대비 열효율이 높은 콘덴싱 보일러를 설치해 난방비를 절약해줍니다.",
    img: system_02_08,
    type: 2,
  },
  {
    title: "태양광 발전 시스템",
    description: "태양광 발전설비로 생산한 전력을 공용부 전기로 활용함으로써 관리비 절감이 가능해집니다.",
    img: system_02_09,
    type: 2,
  },
  {
    title: "지하주차장 100% LED 디밍제어",
    description: "수명이 긴 저에너지 LED 조명 시스템을 사용하여, 지하주차장의 차량 및 보행자의 이동 동선에 따라 밝기를 자동으로 제어함으로써 에너지 소비량을 최적화하여 공용관리비 절감에 도움이 됩니다.",
    img: system_02_10,
    type: 2,
  },

  // 건강 시스템 (type = 3)
  {
    title: "통합 공기질 센서+실내 공기질 모니터링 시스템",
    description: "미세먼지, 초미세먼지, 이산화탄소, 휘발성유기화합물의 4가지 유해 물질을 감지하여 실내 공기질 상태를 월패드에서 실시간으로 확인할 수 있습니다.",
    img: system_03_01,
    type: 3,
  },
  {
    title: "세대 공기청정형 전열 교환 환기시스템+초미세먼지도 걸러내는 헤파필터",
    description: "초미세먼지도 걸러내는 공기청정 전열교환 환기시스템/ 환기만 가능했던 전열교환 환기장치에서 진보된  공기청정 환기시스템으로 외부의 오염된 공기를 차단하고 고성능 헤파필터로 초미세먼지까지 정화하며, 계절에 상관없이 세대 내 공기를 항상 깨끗하고 쾌적하게 만들어줍니다.",
    img: system_03_02,
    type: 3,
  },
  {
    title: "렌지후드 연동 환기 시스템",
    description: "미세먼지를 마시며 요리하던 생활은 끝. 기존의 렌지후드와 달리 미세먼지는 빨아들이고 맑은 공기는 채워주는 자동 환기를 통해 주방 공기를 건강하게 지켜줍니다.",
    img: system_03_03,
    type: 3,
  },
  {
    title: "새집증후군 걱정 제로",
    description: "새집 증후군 걱정이 없습니다. 입주 전 미리 환기를 통한 베이크 아웃을 실시하여 혹시라도 있을지 모르는 유해 물질을 배출하여 실내공기를 청정하게 만듭니다.",
    img: system_03_04,
    type: 3,
  },
  {
    title: "웨더스테이션",
    description: "단지 내 웨더스테이션이 설치되어 미세먼지 상태를 쉽게 확인할 수 있습니다.",
    img: system_03_05,
    type: 3,
  },
  // {
  //   title: "환기시스템과 공기청정형 에어컨으로 늘 쾌적한 커뮤니티",
  //   description: "집에서 보다 다양한 활동을 많이 하는 단지 커뮤니티. 헤파 필터가 적용된 전열 교환 환기 시스템과 공기청정형 에어컨으로 창문을 열지 않아도 실내가 늘 쾌적해집니다.",
  //   img: system_03_06,
  //   type: 3,
  // },
  {
    title: "동 출입구 에어커튼",
    description: "동 출입구마다 설치된 에어커튼이 외부의 미세먼지를 차단하여 쾌적한 환경을 유지시켜 줍니다.",
    img: system_03_07,
    type: 3,
  },
  {
    title: "지하주차장 자동환기 시스템",
    description: "지하주차장의 일산화탄소 농도를 측정하여 목표 농도보다 높을 경우 자동으로 환기팬이 작동하고 배출시켜 언제나 청정한 상태를 유지합니다.",
    img: system_03_08,
    type: 3,
  },
  {
    title: "지하주차장 결로방지팬",
    description: "습기 많은 장마철에 결로가 생겨 곰팡이가 번식하는 것을 막을 수 있도록 지하주차장에도 결로 방지팬을 설치하여 결로를 방지합니다.",
    img: system_03_09,
    type: 3,
  },
  {
    title: "지하 엘리베이터홀 제습",
    description: "자칫 눅눅한 공간이 될 수 있는 지하 엘리베이터홀에 제습기를 설치하여 쾌적함이 유지되도록 관리합니다.",
    img: system_03_10,
    type: 3,
  },

  // 편의 시스템 (type = 4)
  {
    title: "e편한세상 스마트홈",
    description: "기존 월패드의 모든 기능을 어플리케이션으로 옮겨 휴대폰, 태블릿 등 스마트 기기만으로 언제 어디서나 집의 상태를 확인하고 가스, 조명을 원격으로 제어할 수 있습니다.",
    img: system_04_01,
    type: 4,
  },
  {
    title: "에어컨 배관 시스템",
    description: "거실과 안방 에어컨용 냉매배관을 별도로 시공하여 에어컨을 깔끔하고 편리하게 설치할 수 있습니다. (거실:스탠드형 위치, 안방:벽걸이형 위치, 천장형에어컨 옵션선택시 제외)",
    img: system_04_02,
    type: 4,
  },
  {
    title: "식탁 팬던트용 예비 스위치",
    description: "주방 스위치에 예비 스위치를 제공하여 원하는 라이프스타일과 개성에 맞춰 식탁 팬던트를 손쉽게 설치 할 수 있습니다.",
    img: system_04_03,
    type: 4,
  },
  {
    title: "무인택배",
    description: "각 동에 설치되어 있는 무인택배함으로 입주민들이 택배 기사와 대면 없이 물품 및 택배를 수령, 발송 할 수 있어 바쁜 현대생활에 꼭 필요한 양방향 택배 시스템을 제공합니다. (냉동,냉장함미적용)",
    img: system_04_04,
    type: 4,
  },
  {
    title: "전기차 충전소",
    description: "전기자동차 시대를 대비해 지하주차장에 전기차 충전 시스템을 계획하여 전기자동차 충전이 필요할 때 공용으로 사용하실 수 있습니다.",
    img: system_04_05,
    type: 4,
  },
  {
    title: "스마트폰 원패스",
    description: "스마트폰을 소지하고 있으면 동선에 따라 자동으로 공동현관 출입구가 열리고 엘리베이터가 호출되는 최첨단 시스템으로 누구보다 편리한 스마트 라이프를 누릴 수 있습니다.",
    img: system_04_06,
    type: 4,
  },
  {
    title: "주차위치 인식 서비스",
    description: "주차 위치를 따로 기억하지 않고 스마트폰으로 쉽게 확인할 수 있어 외출시 편리합니다.",
    img: system_04_07,
    type: 4,
  },
  {
    title: "주차유도 시스템",
    description: "대형 쇼핑몰, 백화점처럼 주차가 가능한 곳은 녹색등, 불가능 한 곳은 빨간등으로 표기하여 주차할 곳을 빠르게 찾을 수 있습니다.",
    img: system_04_08,
    type: 4,
  },
  
  // 소음저감 시스템 (type = 5)
  {
    title: "층간 소음을 대폭 줄여주는 60T 완충재",
    description: "일반 아파트보다 2배 두꺼운 60mm 바닥차음재를 적용하여, 층간소음을 획기적으로 줄일 뿐만 아니라 난방에너지까지도 절약할 수 있습니다.",
    img: system_05_01,
    type: 5,
  },
  {
    title: "방음효과가 뛰어난 이중창호",
    description: "모든 창호에 이중 창호 시스템을 적용하여 외부의 소음뿐 아니라 냉기까지 차단하여 쾌적한 주거환경이 실현됩니다.",
    img: system_05_02,
    type: 5,
  },
  {
    title: "주방 및 욕실 직배기 시스템",
    description: "공동 배관을 통해 주방, 욕실 공기를 배출하는 일반 아파트와 달리 외부로 직접 배출하여 소음을 원천 차단하고 더 쾌적한 공기 순환이 가능합니다.",
    img: system_05_03,
    type: 5,
  },
  {
    title: "팬분리형 렌지후드",
    description: "렌지 후드의 소음 원인인 팬을 별도로 분리하여 주방에서의 소음은 줄이고 배기 성능은 개선하여 쾌적한 실내환경을 제공합니다.",
    img: system_05_04,
    type: 5,
  },
]